import styled from "styled-components";
import { media } from "../../../../utils";

export const HeaderSection = styled.div`
  background-color: ${({ theme }) => theme.color.brandSecondary.dark};
  color: ${({ theme }) => theme.color.line.light};
`;

export const DownloadsContent = styled.div`
  border-top: 1px solid ${({ theme }) => theme.color.line.medium};
  padding: 30px 10px;
`;

export const ItemsDownloadContent = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const ItemDownload = styled.div`
  display: flex;
  padding: 16px 0;
  width: 100%;
  justify-content: space-between;
  border-bottom: 1px solid ${({ theme }) => theme.color.line.medium};

  ${media.md()} {
    width: 45%;
  }

  p {
    margin: 0;
  }
`;

export const TextTitleContent = styled.p`
  color: ${({ theme }) => theme.color.neutral["03"]};
`;

export const Subtitle = styled.p`
  color: ${({ theme }) => theme.color.neutral["03"]};
`;
